import type { ReactNode } from "react";

export function Centred({ children, spinner = false }: { children: ReactNode; spinner?: boolean }) {
    return (
        <div className="centred">
            {spinner && <div className="spinner" aria-hidden />}
            <div className="muted">{children}</div>
        </div>
    );
}

export function EmptyState({ title, body, action }: { title: string; body?: string; action?: ReactNode }) {
    return (
        <div className="empty">
            <h2>{title}</h2>
            {body && <p className="muted">{body}</p>}
            {action}
        </div>
    );
}

export function ErrorState({ title, body, retry }: { title: string; body?: string; retry?: () => void }) {
    return (
        <div className="empty error">
            <h2>{title}</h2>
            {body && <p className="muted">{body}</p>}
            {retry && <button className="btn" onClick={retry}>Try again</button>}
        </div>
    );
}
